import React, { FC } from 'react';

import {default as SelectAtlaskit, AsyncSelect as AsyncSelectAtlaskit } from '@atlaskit/select';

import { FieldProps as FormikFieldProps, Field, FieldProps } from 'formik';
import { Props } from 'react-select/src/Select';
import { Option } from 'react-select/src/filters';
import { ValueType } from 'react-select/src/types';
import { SelectItem, SelectOption } from './SelectItem';
import { InputVisualizacaoRender, SelectVisualizacaoRender } from 'view/component/Input/InputVisualizacaoRender';
import Spinner from '@atlaskit/spinner';
import { LoadingTexto } from '../Tipografia/Texto';

import './select.css'
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';



export interface SelectProps extends Props<SelectOption> {
  inputId: string;
  /**
   * Ocorreu algum erro ao tentar obter os dados?
   * 
   * Faz sentido utilizar quando os valores são carregados de forma assíncrona fora do Select,
   * ou seja, sem ser responsabilidade do AsyncSelect.
   */
  isLoadingError?: boolean
}


export const Select: React.FC<SelectProps> = ({async=false, ...props}) => {
  const restricaoProps = useCampoFormularioProps(props.inputId, undefined);

  if (restricaoProps.hidden)
    return <></>

  if (restricaoProps.readOnly) {
    return (
      <Field {...props}>
        {(formikProps: FormikFieldProps) => <ConteudoVisualizacao formikProps={formikProps} {...props} />}
      </Field>
    )
  }

  return <SelectPadraoField
    async={async}
    restricaoProps={restricaoProps}
    {...props} />
}

interface ConteudoVisualizacaoProps extends SelectProps {
  formikProps: FieldProps;
}

const ConteudoVisualizacao: FC<ConteudoVisualizacaoProps> = ({formikProps, ...props}) => {
  const restricaoProps = useCampoFormularioProps(props.inputId, undefined);

  const carregando = props.isLoading || restricaoProps.loading;
  const erroDuranteCarregamento = props.isLoadingError === true;
  const itens = InputVisualizacaoRender.select(props, formikProps)
  const hasValor = itens !== undefined;

  if ((!hasValor && carregando) || erroDuranteCarregamento) {
    return <div className={`select ${props.className}`}>
      <LoadingTexto width={120} />
      {props.children}
    </div>
  }

  return <div className={`select ${props.className ?? ''}`}>
    {itens ?? 'A definir'}
    {carregando && <> <Spinner /></>}
    {props.children}
  </div>
}


Select.defaultProps = {
  formatOptionLabel: SelectItem,
  isMulti: false
}

const onChange = (option: ValueType<SelectOption | Option | Option[], any>, formikProps: FormikFieldProps, props: SelectProps) => {
  return formikProps.form.setFieldValue(
    formikProps.field.name,
    props.isMulti
      ? (option as Option[])?.map((item: Option) => item.value)
      : option ? (option as Option).value : undefined
  );
};

const SelectPadraoField: React.FC<SelectProps> = ({async, restricaoProps, ...props}) => {
  const Tag = async ? AsyncSelectAtlaskit : SelectAtlaskit as any;
  const textoCarregando = () => 'Carregando...';
  const textoSemOpcoes = () => 'Sem opções';

  // OP#3859 Forçar que o preview dos elementos selecionados apareçam adequadamente
  const stylesFix = {
    valueContainer: (base: any) => ({ ...base, '> div': {width: 'initial !important'}})
  }

  return <Field {...props}>
    {(formikProps: FormikFieldProps) => <>
      <Tag
        isDisabled={restricaoProps.disabled || props.isLoadingError === true  || formikProps.form.isSubmitting}
        isClearable={restricaoProps.clearable}
        styles={stylesFix}

        value={SelectVisualizacaoRender.getValue(props, formikProps.field)}
        onChange={(option: ValueType<SelectOption, any>) => onChange(option, formikProps, props)}
        onBlur={formikProps.field.onBlur}
        loadingMessage={textoCarregando}
        noOptionsMessage={textoSemOpcoes}

        {...props}
        className={`select ${props.className ?? ''}`}
      />
      {props.children}
    </>
    }
  </Field>
}
